/** True when the address already carries a query the form should clear. */
export function routeQueryHasValues(query: Record<string, unknown> | null | undefined): boolean {
    if (!query) {
        return false;
    }
    return Object.keys(query).some((key) => {
        const value = query[key];
        if (Array.isArray(value)) {
            return value.some((item) => String(item ?? '').trim() !== '');
        }
        return value !== undefined && value !== null && String(value).trim() !== '';
    });
}

/** Vue Router rejects a second visit to the page the user is already on. */
export function isRedundantNavigation(error: {name?: string; message?: string} | null | undefined): boolean {
    if (!error) {
        return false;
    }
    if (error.name === 'NavigationDuplicated') {
        return true;
    }
    return /redundant navigation/i.test(String(error.message || ''));
}
